<template>
    <div class="container">

        <form id="payment_confirmation" action="https://testsecureacceptance.cybersource.com/pay"  method="post" >
            <div v-if="loading" class="col text-center">
                <loading-component ></loading-component>
            </div>
            <div v-else id="step2" >
                <br>
                <div class="row">
                    <div class="col-12 top-room-info">
                        <div>
                            <h4 class=" mt-1">
                                Room & Price Summary
                            </h4>
                        </div>
                        <div class=" col-sm-12 pl-0 pr-0" @click="imageDialogVisible = true">
                            <el-image
                                style="width: 100%; height: 250px"
                                :src="this.data.roomImage"
                                :fit="'cover'"/>
                        </div>
                        <br>
                        <h5 class="room-type-title">
                            {{this.roomType.name}}
                        </h5>
                        <div class="col">
                            <div class="row dashed-bottom-border pb-1 pt-2">
                                <div class="col">
                                    <label>Room Theme</label>
                                </div>
                                <div class="col text-right">
                                    <label style="color: black !important;">{{this.roomTheme.name}}</label>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" id="" name="payment">
                        <div class="col">
                            <div class="row dashed-bottom-border pb-1 pt-2">
                                <div class="col">
                                    <label>Checkin Date</label>
                                </div>
                                <div class="col text-right">
                                    <label style="color: black !important;">{{this.checkinDate[0]}} /{{ this.checkinDate[1] }} /{{this.checkinDate[2] }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row dashed-bottom-border pb-1 pt-2">
                                <div class="col">
                                    <label>Checkout Date</label>
                                </div>
                                <div class="col text-right">
                                    <label style="color: black !important;">{{this.checkoutDate[0]}}/ {{ this.checkoutDate[1]}} /{{ this.checkoutDate[2]}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row dashed-bottom-border pb-1 pt-2">
                                <div class="col">
                                    <label>Number of Rooms</label>
                                </div>
                                <div class="col text-right">
                                    <label style="color: black !important;">{{this.data.room}} Room(s)</label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row dashed-bottom-border pb-1 pt-2  ">
                                <div class="col">
                                    <label>Night</label>
                                </div>
                                <div class="col text-right">
                                    <label style="color: black !important;">{{this.data.numberOfNightToStay}} Night(s)</label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row pb-1 pt-2">
                                <div class="col">
                                    <b><label>Total Price</label></b>
                                </div>
                                <div class="col text-right">
                                        <label  v-if="couponResult[1]">${{(this.data.totalPrice * this.data.room) - (this.data.totalPrice * this.data.room) * (couponResult[0]/100)}}</label>
                                        <label v-else>${{this.data.totalPrice * this.data.room}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card col-sm-12 col-md-7">
                        <input type="hidden" v-model="access_key" name="access_key" id="access_key" >
                        <input type="hidden" v-model="profile_id" name="profile_id" id="profile_id">
                        <input type="hidden" v-model="transaction_uuid" name="transaction_uuid" value="">
                        <input type="hidden" v-model="signed_field_names" name="signed_field_names" value="access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency">
                        <input type="hidden" v-model="unsigned_field_names" name="unsigned_field_names">
                        <input type="hidden" v-model="signed_date_time" name="signed_date_time" >
                        <input type="hidden" v-model="locale" name="locale" >
                        <input type="hidden" v-model="signature" name="signature">
                        <input v-model="transaction_type" type="hidden" name="transaction_type" size="25"><br/>
                        <input v-model="reference_number" type="hidden" name="reference_number" size="25"><br/>
                        <input v-model="amount" type="hidden" name="amount" size="25"><br/>
                        <input v-model="currency" type="hidden" name="currency" size="25"><br/>
                        <input type="hidden" v-model="first_name" name="bill_to_forename" id="bill_to_forename">
                        <input type="hidden" v-model="last_name" name="bill_to_surname" id="bill_to_surname">
                        <input type="hidden" v-model="email" name="bill_to_email" id="bill_to_email">
                        <input type="hidden" v-model="phone_number" name="bill_to_phone" id="bill_to_phone">
                        <input type="hidden" v-model="address" name="bill_to_address_line1"
                               id="bill_to_address_line1">
                        <input type="hidden" v-model="city" name="bill_to_address_city"
                               id="bill_to_address_city">
                        <div class="mt-0">
                            <h4 class="card-title">
                                Guest Information
                            </h4>
                            <div class="row">
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Social title</label>
                                    <select class="form-control" v-model="social_title" name="social_title" id="socialTitle">
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">First Name *</label>
                                    <input
                                        v-model="first_name"
                                        class="form-control"
                                        :class="errors.has('first_name')?'is-danger':''"
                                        v-validate="'required'"
                                        type="text"
                                        name="first_name"
                                        id="firstName" >
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Last Name *</label>
                                    <input
                                        v-model="last_name"
                                        v-validate="'required'"
                                        :class="errors.has('last_name')?'is-danger':''"
                                        class="form-control"
                                        type="text"
                                        name="last_name"
                                        id="lastName" >
                                </div>
                            </div>
                            <div class="row mt-3">
                                    <div class="col-sm-12 col-md-6">
                                        <label class="mb-0 mt-3">Email *</label>
                                        <input
                                            v-model="email"
                                            v-validate="'required'"
                                            :class="errors.has('email')?'is-danger':''"
                                            class="form-control" type="email" name="email"  id="email" >
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <label class="mb-0 mt-3">Phone Number *</label>
                                        <input
                                            v-model="phone_number"
                                            v-validate="'required'"
                                            :class="errors.has('phone_number')?'is-danger':''"
                                            class="form-control" type="number" name="phone_number"  id="phoneNumber" >
                                    </div>
                                </div>
                        </div>
                        <div class=" mt-3">
                            <h4 class="card-title">
                                Personal information <small class="text-muted">( optional )</small>
                            </h4>
                            <div class="row">
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Country</label>
                                    <select class="form-control" v-model="country" name="country" id="country">
                                        <option v-for="country in  country_list">{{country}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Address</label>
                                    <input class="form-control" v-model="address" type="text" name="address"  id="address" >
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Zip Code</label>
                                    <input class="form-control" v-model="zip_code" type="text" name="zip_code"  id="zipCode" >
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-12 col-md-4">
                                    <label class="mt-3 mb-0">Postal Code</label>
                                    <input class="form-control" v-model="postal_code" type="text" name="postal_code"  id="postalCode" >
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">City</label>
                                    <input class="form-control" v-model="city" type="text" name="city"  id="city" >
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <label class="mb-0 mt-3">Telephone</label>
                                    <input class="form-control" v-model="telephone" type="number" name="telephone"  id="telephone" >
                                </div>
                            </div>
                        </div>
                        <div class=" mt-3">
                            <h4 class="card-title">
                                Payment Information
                            </h4>
                            <div class="" id="nav-bank" >
                                <hr>
                                <h6>This is our bank account</h6>
                                <ul>
                                    <li v-for="account in bankAccounts">{{account.name}} : {{account.account_number}}</li>
                                </ul>
                                <el-switch
                                    @change="getSignature"
                                    v-model="pay_with_card"
                                    active-text="Pay With Card">
                                </el-switch>
                            </div>
                        </div>
                        <div class="mt-3 mb-3">
                            <h4>
                                Voucher/Promo code <small class="text-muted">( optional )</small>
                            </h4>
                            <div class="">
                                <div class="row">
                                    <p class="col-11">
                                        If you have a voucher/promotional code for this booking,
                                        please enter it below and click “Apply”
                                    </p>
                                    <div class="col-8 pr-0">
                                        <input class="form-control" type="text" name="voucher_code"  id="voucherCode" style="border-top-right-radius: 0;border-bottom-right-radius: 0">
                                    </div>
                                    <div class="col-4 mt-2 pl-0">
                                        <button class="btn btn-secondary btn-block" type="button" @click="checkCoupon()" style="border-radius: 0;height: 38px;margin-top: -8px;">Apply</button>
                                    </div>
                                </div>
                                <p v-if="couponResult[1]" style="color: green">This Voucher Code is valid. And You got $ {{couponResult[0]}} discount!!</p>
                                <p v-if="couponResult[1] == false" style="color: red">This Voucher Code is not valid!!</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-5">
                        <div class="p-1 col-12" >
                            <div class="card-body room-info border" style="background-color: white !important;">
                                <div>
                                    <h4 class="mb-2">
                                        Room & Price Summary
                                    </h4>
                                </div>
                                <div class="row">
                                    <div class="col-12 fill" type="" data-toggle="modal" data-target="#exampleModal">
                                        <el-image
                                            style="width: 100%; height: 250px"
                                            :src="this.data.roomImage"
                                            :fit="'cover'"/>
                                    </div>

                                    <div class="col-12">
                                        <br>
                                        <h5 class="bg-orange">
                                            {{this.roomType.name}}
                                        </h5>
                                        <div style="font-size: 2rem; margin-top: 1px" class="pl-2 pt-0">
                                            <el-popover
                                                placement="top"
                                                title="Wi-Fi"
                                                width="100"
                                                trigger="hover"
                                                content="Wi-Fi Included">

                                                <b-icon slot="reference" style="border-radius: 5px;border-style: dashed !important;" icon="wifi" class="border   p-2" variant=""></b-icon>

                                            </el-popover>
                                            <el-popover
                                                placement="top"
                                                title="Widescreen Tv"
                                                width="200"
                                                trigger="hover"
                                                content="Widescreen Tv Included">

                                                <b-icon slot="reference" style="border-radius: 5px;border-style: dashed !important; " icon="tv" class="border   p-2" variant=""></b-icon>

                                            </el-popover>
                                            <el-popover
                                                placement="top"
                                                title="Private Balcony"
                                                width="200"
                                                trigger="hover"
                                                content="Private Balcony Included">

                                                <b-icon slot="reference" style="border-radius: 5px;border-style: dashed !important;" icon="eye-slash-fill" class="border   p-2" variant=""></b-icon>

                                            </el-popover>
                                        </div>
                                        <br>
                                        <input type="hidden" id="paymentStep2" name="payment">
                                        <table class="table table-responsive-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td>Room Theme</td>
                                                    <td>{{this.roomTheme.name}} </td>
                                                </tr>
                                                <tr>
                                                    <td>Checkin Date</td>
                                                    <td>{{this.checkinDate[0]}} /{{ this.checkinDate[1] }} /{{this.checkinDate[2] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Checkout Date</td>
                                                    <td>{{this.checkoutDate[0]}}/ {{ this.checkoutDate[1]}} /{{ this.checkoutDate[2]}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Number of Rooms</td>
                                                    <td>{{this.data.room}} Room(s)</td>
                                                </tr>
                                                <tr>
                                                    <td>Number of Night To Stay</td>
                                                    <td>{{this.data.numberOfNightToStay}} Night(s)</td>
                                                </tr>
                                                <tr v-if="couponResult[1]">
                                                    <td>Discount</td>
                                                    <td>$ {{couponResult[0]}} </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Price</td>
                                                    <td  v-if="couponResult[1]">${{(this.data.totalPrice * this.data.room) - (this.data.totalPrice * this.data.room) * (couponResult[0]/100)}}</td>
                                                    <td v-else>${{this.data.totalPrice * this.data.room}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <el-checkbox v-model="agreement" @change="confirmTerms">
                                            <p>
                                                Confirm.
                                                <a href="#" @click="dialogTermsAndConditionsVisible = true">(Read the Terms of Service)</a>
                                            </p>
                                        </el-checkbox>
                                    </div>
                                    <button :class="agreement ?'':'disable'" class="btn btn-block" type="button" @click="confirmAndBook()" style="background-color: #EF6E4A">
                                        <span style="color:white ">Confirm & Book</span>
                                    </button>
                                    <button class="btn btn-secondary btn-block" @click="hidePersonalPage()" >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><br>
            <el-dialog
                title="Successfully Booked!!"
                :visible.sync="dialogVisible"
                width="30%"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :before-close="handleClose">
                Thanks for choosing our Hotel!!<br>
                And this is your ticket number <label class="text-muted ml-3">{{this.ticket_number}}</label>
                <span slot="footer" class="dialog-footer">
                <el-button class="btn btn-warning btn-block" @click="successExit()" style="background-color: #EF6E4A">Ok</el-button>
              </span>
            </el-dialog>

            <el-dialog title="Terms And Conditions" :visible.sync="dialogTermsAndConditionsVisible">

            </el-dialog>
        </form>
    </div>
</template>

<script>
    import LoadingComponent from "../common/LoadingComponent";
    export default {
        components : {LoadingComponent},
        name: "SecondStepBookingComponent",
        props: [
          'data',
          'roomOffer',
          'roomTheme',
            'payment_profile_id',
            'payment_access_key',
            'payment_url',
            'transaction_uuid',
            'signed_date_time',
            'session_id',
        ],
        data() {
            return {

                access_key: '131bb8c760d13a85b6207baba9d364fd',
                profile_id: 'B4592970-B709-4991-8912-5CD9A6538B68',
                signed_field_names: 'access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,bill_to_forename,bill_to_surname,bill_to_email',
                unsigned_field_names: '',
                transaction_type: 'sale',
                reference_number: new Date().getTime(),
                locale: 'en',
                amount: this.data.totalPrice * this.data.room,
                currency: 'USD',
                payment_method: 'card',
                signature: '',
                social_title: '',
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                country: '',
                address: '',
                zip_code: '',
                postal_code: '',
                city: '',
                telephone: '',
                pay_with_card:false,
                payment:this.data.totalPrice * this.data.room,

                dialogVisible:false,
                dialogTermsAndConditionsVisible:false,
                loading:false,
                isPaymentWithBank:false,
                isPaymentWithArrival:false,
                checkinDate:[],
                checkOutDate:[],
                numberOfRoomNeeded:'',
                totalPrice:'',
                nightToStay:'',
                expireDate:'',
                personalPage:Boolean,
                roomType:[],
                booked:false,
                couponResult:[],
                coupon_id:'',
                ticket_number:'',
                bankAccounts:[],
                agreement:false,
                country_list : [
                    'Afghanistan',
                    'Albania',
                    'Algeria',
                    'Andorra',
                    'Angola',
                    'Anguilla',
                    'Antigua',
                    'Argentina',
                    'Armenia',
                    'Aruba',
                    'Australia',
                    'Austria',
                    'Azerbaijan',
                    'Bahamas',
                    'Bahrain',
                    'Bangladesh',
                    'Barbados',
                    'Belarus',
                    'Belgium',
                    'Belize',
                    'Benin',
                    'Bermuda',
                    'Bhutan',
                    'Bolivia',
                    'Bosnia Herzegovina',
                    'Botswana',
                    'Brazil',
                    'British Virgin Islands',
                    'Brunei',
                    'Bulgaria',
                    'Burkina Faso',
                    'Burundi',
                    'Cambodia',
                    'Cameroon',
                    'Canada',
                    'Cape Verde',
                    'Cayman Islands',
                    'Chad',
                    'Chile',
                    'China',
                    'Colombia',
                    'Congo',
                    'Cook Islands',
                    'Costa Rica',
                    'Cote D Ivoire',
                    'Croatia',
                    'Cruise Ship',
                    'Cuba',
                    'Cyprus',
                    'Czech Republic',
                    'Denmark',
                    'Djibouti',
                    'Dominica',
                    'Dominican Republic',
                    'Ecuador',
                    'Egypt',
                    'El Salvador',
                    'Equatorial Guinea',
                    'Estonia',
                    'Ethiopia',
                    'Falkland Islands',
                    'Faroe Islands',
                    'Fiji',
                    'Finland',
                    'France',
                    'French Polynesia',
                    'French West Indies',
                    'Gabon',
                    'Gambia',
                    'Georgia',
                    'Germany',
                    'Ghana',
                    'Gibraltar',
                    'Greece',
                    'Greenland',
                    'Grenada',
                    'Guam',
                    'Guatemala',
                    'Guernsey',
                    'Guinea',
                    'Guinea Bissau',
                    'Guyana',
                    'Haiti',
                    'Honduras',
                    'Hong Kong',
                    'Hungary',
                    'Iceland',
                    'India',
                    'Indonesia',
                    'Iran',
                    'Iraq',
                    'Ireland',
                    'Isle of Man',
                    'Israel',
                    'Italy',
                    'Jamaica',
                    'Japan',
                    'Jersey',
                    'Jordan',
                    'Kazakhstan',
                    'Kenya',
                    'Kuwait',
                    'Kyrgyz Republic',
                    'Laos',
                    'Latvia',
                    'Lebanon',
                    'Lesotho',
                    'Liberia',
                    'Libya',
                    'Liechtenstein',
                    'Lithuania',
                    'Luxembourg',
                    'Macau',
                    'Macedonia',
                    'Madagascar',
                    'Malawi',
                    'Malaysia',
                    'Maldives',
                    'Mali',
                    'Malta',
                    'Mauritania',
                    'Mauritius',
                    'Mexico',
                    'Moldova',
                    'Monaco',
                    'Mongolia',
                    'Montenegro',
                    'Montserrat',
                    'Morocco',
                    'Mozambique',
                    'Namibia',
                    'Nepal',
                    'Netherlands',
                    'Netherlands Antilles',
                    'New Caledonia',
                    'New Zealand',
                    'Nicaragua',
                    'Niger',
                    'Nigeria',
                    'Norway',
                    'Oman',
                    'Pakistan',
                    'Palestine',
                    'Panama',
                    'Papua New Guinea',
                    'Paraguay',
                    'Peru',
                    'Philippines',
                    'Poland',
                    'Portugal',
                    'Puerto Rico',
                    'Qatar',
                    'Reunion',
                    'Romania',
                    'Russia',
                    'Rwanda',
                    'Saint Pierre Miquelon',
                    'Samoa',
                    'San Marino',
                    'Satellite',
                    'Saudi Arabia',
                    'Senegal',
                    'Serbia',
                    'Seychelles',
                    'Sierra Leone',
                    'Singapore',
                    'Slovakia',
                    'Slovenia',
                    'South Africa',
                    'South Korea',
                    'Spain',
                    'Sri Lanka',
                    'St Kitts Nevis',
                    'St Lucia',
                    'St Vincent',
                    'Sudan',
                    'Suriname',
                    'Swaziland',
                    'Sweden',
                    'Switzerland',
                    'Syria',
                    'Taiwan',
                    'Tajikistan',
                    'Tanzania',
                    'Thailand',
                    'Timor L Este',
                    'Togo',
                    'Tonga',
                    'Trinidad Tobago',
                    'Tunisia',
                    'Turkey',
                    'Turkmenistan',
                    'Turks Caicos',
                    'Uganda',
                    'Ukraine',
                    'United Arab Emirates',
                    'United Kingdom',
                    'United States',
                    'United States Minor Outlying Islands',
                    'Uruguay',
                    'Uzbekistan',
                    'Venezuela',
                    'Vietnam',
                    'Virgin Islands (US)',
                    'Yemen',
                    'Zambia',
                    'Zimbabwe'
                ]
            }
        },
        methods : {
            hidePersonalPage : function () {
                this.personalPage = false;
                this.$emit('secondProgress', false)
            },
            successExit : function () {
                this.dialogVisible = false ;
                this.personalPage = false;
                this.$emit('secondProgress', false)
            },
            confirmAndBook () {
                if(true)
                {
                    axios.post('/book', {
                        checkinDate: this.data.checkinDate,
                        checkoutDate: this.data.checkoutDate,
                        room: this.data.room,
                        adult: this.data.adult,
                        payment: this.payment,
                        children: this.data.children,
                        infant: this.data.infant,
                        social_title: $('#socialTitle').val(),
                        first_name: $('#firstName').val(),
                        last_name: $('#lastName').val(),
                        email: $('#email').val(),
                        phone_number: $('#phoneNumber').val(),
                        card_number: $('#cardNumber').val(),
                        expire_date: $('#expireDate').val(),
                        card_holder_name: $('#cardHolderName').val(),
                        country: $('#country :selected').text(),
                        address: $('#address').val(),
                        zip_code: $('#zipCode').val(),
                        postal_code: $('#postalCode').val(),
                        city: $('#city').val(),
                        telephone: $('#telephone').val(),
                        coupon_id: this.coupon_id,
                        roomType: this.data.roomType.id,
                        roomTheme: this.roomTheme.id,

                        pay_with_card: this.pay_with_card,
                        transaction_uuid: this.transaction_uuid,
                        signed_date_time: this.signed_date_time,
                        signed_field_names: this.signed_field_names,
                        transaction_type: this.transaction_type,
                        reference_number: this.reference_number,
                        locale: this.locale,
                        amount: this.amount,
                        currency: this.currency,
                        payment_method: this.payment_method,
                        signature: this.signature,

                    }).then(async response => {

                        if(this.pay_with_card)
                        {
                         $("#payment_confirmation").submit()
                        }else {
                            window.location.href = '/confirmation/' + response.data.book.id
                        }
                        this.loading = false;
                            // console.log(response.data)
                    })
                        .catch(error => {
                            console.log(error)
                        });
                }
                // this.$validator.validate().then( valid => {
                //     form.submit();
                //     if (valid) {
                //         this.loading = true;
                //
                //     }
                // });
            },
            getSignature () {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                    type: 'POST',
                    url: '/getPaymentInfo',
                    data: {
                        access_key: this.access_key,
                        profile_id: this.profile_id,
                        transaction_uuid: this.transaction_uuid,
                        signed_field_names: this.signed_field_names,
                        unsigned_field_names: this.unsigned_field_names,
                        signed_date_time: this.signed_date_time,
                        transaction_type: this.transaction_type,
                        reference_number: this.reference_number,
                        locale: this.locale,
                        amount: this.amount,
                        currency: this.currency,

                        bill_to_forename: this.first_name,
                        bill_to_surname: this.last_name,
                        bill_to_email: this.email,
                        bill_to_phone: this.phone_number,
                        bill_to_address_line1: this.address,
                        bill_to_address_city: this.city,
                    },
                    success: function (data) {
                        $("input[name=signature]").val(data);
                        console.log(data);
                    }
                })
            },
            confirmTerms() {
                if (this.pay_with_card) {
                    this.getSignature();
                }

                this.agreement = true
            },
            getNameOfDate : function(date){

                let result = [];
                let day = '';
                let month = '';
                let year = '';
                let date1 = new Date(date);

                day = date1.toString().split(' ')[0];
                month = date1.toString().split(' ')[1] + '-' +date1.getDate();
                year = date1.toString().split(' ')[3];
                result.push(day);
                result.push(month);
                result.push(year);

                return result;

            },
            checkCoupon :function () {
                axios.post('/checkCoupon',{
                    numPeople:this.data.adult + this.data.children + this.data.infant,
                    checkin: this.data.checkinDate,
                    checkout: this.data.checkoutDate,
                    code:$('#voucherCode').val()
                })
                .then(response => {
                    this.couponResult = response.data;
                    if(this.couponResult != 0)
                    {
                        this.coupon_id = this.couponResult[2];
                        this.payment = this.couponResult[1] ? (this.data.totalPrice * this.data.room) - (this.data.totalPrice * this.data.room) * (this.couponResult[0]/100): this.payment
                    }else {
                        this.coupon_id = null;
                    }
                    console.log(response.data)
                })
            },
            getBankAccount : function () {
                axios.get('/getBankAccounts')
                .then(response => {
                    this.bankAccounts = response.data
                    console.log(this.bankAccounts)
                })
            },
            paymentWithArrival : function () {
                this.isPaymentWithArrival = true;
            },
            paymentWithBank : function () {
                console.log('with Bank')
                this.isPaymentWithBank = true;
            },paymentWithCard : function () {
                console.log('with card')

                this.isPaymentWithBank = false;
            },
            handleClose(done) {
                this.$confirm('Are you sure to close this dialog?')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        },created() {
            this.getBankAccount();
            this.checkinDate = this.getNameOfDate(this.data.checkinDate);
            this.checkoutDate = this.getNameOfDate(this.data.checkoutDate);
            this.roomType = this.data.roomType;
        },
        watch : {
            personalPage: function (newVal,oldVal) {
                this.$emit('personalPage', this.personalPage)
            }
        }
    }
</script>

<style>
    .is-danger{
        border-color: red !important;
    }
    .modal-content{
        position: relative;
        display: flex;
        flex-direction: column;
        margin-top: 50%;
    }
    .modal-header{
        width: 0;
        height: 0;
    }
    .disable{
        cursor: not-allowed;
        pointer-events: none;

        /*Button disabled - CSS color class*/
        color: #c0c0c0;
        background-color: #FFC192 !important;

    }
    .el-dialog__headerbtn{
        display: none !important;
    }
    @media (max-width: 767px) {
        .room-info{
            display: none
        }
    }

    @media (min-width: 767px) {
        .top-room-info{
            display: none
        }
    }


</style>
